module.exports = __webpack_public_path__ + "static/media/money-bag-2.cb192387.svg";